<template>
  <transition name="fade">
    <ul class="lang-switcher" v-show="showLangSwitcher">
      <li class="lang-item"
          @click="setLang('en')"
          :class="{'active': $i18n.locale == 'en'}">
        English
      </li>
      <li class="lang-item"
          @click="setLang('ru')"
          :class="{'active': $i18n.locale == 'ru'}">
        Русский
      </li>
    </ul>
  </transition>
</template>

<script>
  export default {
    name: 'langSwitcher',
    props: {
      showLangSwitcher: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      setLang(lang) {
        localStorage.setItem("lang", lang);
        this.$i18n.locale = lang;
        this.$emit('closeMenu')
      }
    }
  }
</script>

<style lang="scss" scoped>

  .lang-switcher {
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    width: 290px;
    background: white;
    border-radius: 8px;

    &::before {
      content: '';
      position: absolute;
      width: 11px;
      height: 11px;
      background: white;
      transform: rotate(45deg);
      position: absolute;
      left: 23px;
      bottom: -5px;
    }
  }

  .lang-item {
    display: flex;
    align-items: center;
    font-family: $msb;
    font-size: 12px;
    color: $darkBlue;
    letter-spacing: .15px;
    margin: 0;
    width: 100%;
    //cursor: pointer;
    height: 60px;
    box-shadow: 0px 1px 0px #F5F8FA;
    transition: $anim;
    padding: 20px 60px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid $grey;
      background: white;
      transition: $anim;
      left: 20px;
      top: 18px;
      cursor: pointer;
    }

    &.active::before {
      background: $lightBlue;
    }

    &:last-of-type {
      box-shadow: none;
    }

    img {
      box-shadow: none;
      margin-right: 5px;
    }

    &.active {
      color: $lightBlue;
    }
  }

  .lang-item.active button {
    background: $grey;
  }

  .lang-item:last-of-type button {
    border: none;
  }
</style>
